import Colors from '@legacy/common/Constants/Colors'
import styled from 'styled-components'

export const StarsContainer = styled.div`
  border-bottom: 1px solid ${Colors.primary.lightGray};
  flex-direction: column;
  padding: 2rem 0;
  display: flex;
  gap: 2rem;
`